export default __webpack_public_path__ + "static/media/nuhamin.57a24bd0.jpg";